import { ExcludedCascoPackagesEnum } from '@crm/api'
import { useLocales } from '@shared/locales'
import { Col, Form, InputNumber, Row, Select } from 'antd'
import { useMemo } from 'react'

export const CascoCriteriaFields = () => {
  const { t } = useLocales()

  const packageOptions = useMemo(
    () =>
      Object.values(ExcludedCascoPackagesEnum).map((value) => ({
        label: t(`lead_generation.${value}`, value),
        value
      })),
    [t]
  )

  return (
    <Row gutter={[18, 0]}>
      <Col span={24} md={12}>
        <Form.Item
          name="issued_window_days"
          label={t('lead_generation.issued_window_days')}
        >
          <InputNumber min={1} />
        </Form.Item>
      </Col>

      <Col span={24} md={12}>
        <Form.Item
          name="max_vehicle_age_years"
          label={t('lead_generation.max_vehicle_age_years')}
        >
          <InputNumber min={0} />
        </Form.Item>
      </Col>

      <Col span={24}>
        <Form.Item
          name="excluded_casco_packages"
          label={t('lead_generation.excluded_casco_packages')}
          extra={t('lead_generation.excluded_packages_hint')}
        >
          <Select mode="multiple" allowClear options={packageOptions} />
        </Form.Item>
      </Col>
    </Row>
  )
}
